// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__24ckL","emails":"CreateEditClinics_emails__2m6GI","emailTagLabel":"CreateEditClinics_emailTagLabel__3whFf"};